import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'patient-name',
  styles: [require('./patient-name.component.scss')],
  template: require('./patient-name.component.html'),
})
export class PatientNameComponent {
  @Input() name: string;
  @HostBinding('class.is-old-ui') @Input() oldUi: boolean = false;
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/patient-name/patient-name.component.ts